import { render, staticRenderFns } from "./AddModelsToMiddleware.vue?vue&type=template&id=1d8e0ed2&"
import script from "./AddModelsToMiddleware.vue?vue&type=script&lang=js&"
export * from "./AddModelsToMiddleware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports